/**
 * Старая CRM внутри нового интерфейса: страница открыта во фрейме и не рисует свою оболочку —
 * шапку, меню и глобальные виджеты показывает новый интерфейс. Флаг вычисляется один раз при запуске.
 */
export const isEmbedded = globalThis.self !== globalThis.top;

// Адрес родителя переживает уход фрейма на Keycloak и обратно: после возврата referrer указывает на SSO
const PARENT_ORIGIN_KEY = 'embedded-parent-origin';

function readParentOrigin(): string | undefined {
  if (!isEmbedded) return undefined;
  const ancestor = globalThis.location.ancestorOrigins?.[0];
  if (ancestor) return ancestor;
  const saved = sessionStorage.getItem(PARENT_ORIGIN_KEY);
  if (saved) return saved;
  if (!document.referrer) return undefined;
  const origin = new URL(document.referrer).origin;
  sessionStorage.setItem(PARENT_ORIGIN_KEY, origin);
  return origin;
}

const parentOrigin = readParentOrigin();

/** Сообщает новому интерфейсу путь и заголовок страницы; сообщение уходит только родителю. */
export function reportRoute(path: string, title: string): void {
  if (!parentOrigin) return;
  globalThis.parent.postMessage({ source: 'bi-legacy', type: 'route', path, title }, parentOrigin);
}

/**
 * Сообщает новому интерфейсу, что входа во фрейме нет. Страница входа Keycloak во фрейме не открывается,
 * поэтому вход ведёт новый интерфейс: при живой сессии он перезагружает фрейм, без неё уводит на вход всё окно.
 */
export function reportAuthRequired(): void {
  if (!parentOrigin) return;
  globalThis.parent.postMessage({ source: 'bi-legacy', type: 'auth-required' }, parentOrigin);
}
